export default __webpack_public_path__ + "static/media/Group1.d13604a5.png";